import { Box } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import useOnboardingMeetingData from 'modules/onboarding/hooks/useOnboardingMeetingData'
import type { MeetingPayload } from 'modules/onboarding/lib/hubspot/meetings'

import HubspotChatWrapper from '../../HelpWidget/WidgetSidepanel/HubspotChatWrapper'
import HubspotMeetingsWrapper from '../../HelpWidget/WidgetSidepanel/HubspotMeetingsWrapper'
import { MeetingData } from './types'

interface Props {
  isChatOpen?: boolean
  isMeetingOpen?: boolean
  isUpsellMeeting?: boolean
  onClose: () => void
}

const HubspotModal = ({ isChatOpen, isMeetingOpen, isUpsellMeeting = false, onClose }: Props) => {
  const { writeData } = useOnboardingMeetingData()

  const onMeetingBooked = (data: MeetingPayload) => {
    if (!data) {
      return
    }
    if (data.meetingBookSucceeded) {
      const duration = Math.floor(
        (data.meetingsPayload?.bookingResponse.event.duration / 1000 / 60) % 60
      ).toString()
      const meetingDate = new Date(
        data.meetingsPayload.bookingResponse.event.dateTime
      ).toISOString()

      const meeting: MeetingData = {
        meetingDate: meetingDate,
        meetingDuration: duration,
        meetingBookSucceeded: data.meetingBookSucceeded,
      }

      writeData(meeting)
    }
  }

  const getTitle = () => {
    if (isChatOpen) {
      return i18n.t('pricing_plans.help_info.hubspot_modal.title_chat')
    } else if (isUpsellMeeting) {
      return i18n.t('upsell.book_a_meeting')
    } else {
      return i18n.t('pricing_plans.help_info.hubspot_modal.title_demo')
    }
  }

  return (
    <Modal
      title={getTitle()}
      illustration={isChatOpen ? 'laptop-user' : 'calendar'}
      onClose={onClose}
    >
      <Box height={'s600'}>
        {isChatOpen && <HubspotChatWrapper />}
        {isMeetingOpen && (
          <HubspotMeetingsWrapper
            isUpsellMeeting={isUpsellMeeting}
            onMeetingBooked={onMeetingBooked}
          />
        )}
      </Box>
    </Modal>
  )
}

export default HubspotModal
